import { Subject, Subscription, of, race } from 'rxjs';
import { delay, filter, take, timeInterval } from 'rxjs/operators';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ['timeout'],
    template: require('./touchable.html'),
})
export class Touchable extends Vue {
    public timeout: number;
    public touched = false;

    private touch$ = new Subject()

    public onTouchStart(event: TouchEvent) {
        this.touched = true
        this.touch$.next(event)

        // if the user is clicking since timeout seconds
        const timer$ = of({ interval: this.timeout + 1, value: {type: 'touchend'} }).pipe(
            delay(this.timeout + 1)
        )

        // if the user realease his finger
        const touchend$ = this.touch$.pipe(
            timeInterval(),
            filter(({interval, value}) => {
                if ((value as TouchEvent).type === 'touchend') {
                    return true
                }
                return false
            }),
            take(1)
        )

        race(
            timer$,
            touchend$,
        ).subscribe(({interval, value}) => {
            if (interval > this.timeout) {
                this.touched = false
                this.$emit('touchtimed')
            }
        })
    }

    public onTouchEnd(event: TouchEvent) {
        this.touched = false;
        this.touch$.next(event);
    }

    public onContextMenu(event: TouchEvent) {
        event.preventDefault();
        this.touched = false;
        this.touch$.next({
            ...event,
            type: 'touchend',
        });
    }

    public onTouchMove(event: TouchEvent) {
        this.touch$.next(event);
    }
}
